module.exports = __webpack_public_path__ + "static/media/censoComunalAlcaldesa.60a4a86d.mp3";